import { useState, useRef } from "react";

export const ExampleQuestions = () => {
  const [expandedSources, setExpandedSources] = useState<
    Record<number, boolean>
  >({});

  const tableRef = useRef<HTMLDivElement>(null);

  const toggleSource = (id: number) => {
    setExpandedSources((prev) => {
      const newState = { ...prev, [id]: !prev[id] };

      // If we're collapsing (going from true to false), scroll to top of table
      if (prev[id] === true && newState[id] === false) {
        setTimeout(() => {
          tableRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 0);
      }

      return newState;
    });
  };

  // Function to truncate email content to first N lines
  const truncateEmail = (email: string, maxLines: number = 3) => {
    const lines = email.trim().split("\n");
    if (lines.length <= maxLines) {
      return email;
    }
    return lines.slice(0, maxLines).join("\n");
  };

  const examples = [
    {
      id: 543,
      question:
        "What issues will be discussed at the Tuesday afternoon meeting with EES?",
      answer:
        "What to do about forcing the utilities to pay delinquent PX credits, whether the new 1 cent surcharge should be passed on to our customers, and whether to try to return our customers to utility bundled service.",
      source_email: `Thanks, Harry.  I want to re-enforce the switching issue, since EES is likely 
to be very focused on moving customers back to the utility on Tuesday.  
Switching would certainly reduce EES' going-forward exposure to 1) growing 
"credit receivables" that the utilities refuse to pay and 2) the risk that 
the Commission will end the rate freeze altogether---and the PX credit with 
it--as part of the hearing process that commences with the pre-hearing 
conference on Wednesday.  Reducing that exposure is clealry important to EES.

But the utilities' ability to resist taking back customers is likely to be 
significant, particularly since 90% of the volumes that we serve are on Enron 
meters.  Imagine the road blocks that the utility can/will construct over the 
"complex process"  of changing-out the meters.  In addition, when CA border 
gas prices spiked several weeks ago, many large gas customers tried to switch 
from noncore to core service on SoCalGas' system.  SoCalGas submitted an 
emergency motion at the Commission to prevent the switching and the 
Commission granted it in the wink of an eye.

It will be important for EES to drill down fairly deeply in its analysis of 
all the ways that the utility can frustrate any switching.  Otherwise, we may 
find ourselves confronting a lot of negative PR without having reduced any of 
EES' exposure.  Customers who have been unwillingly switched back to the 
utility have become very vocal about their displeasure and have turned 
negative on ESPs as a result.

Best,
Jeff



	Harry Kingerski
	01/07/2001 11:21 AM
		 
		 To: Steven J Kean/NA/Enron@Enron, Richard Shapiro/NA/Enron@Enron, Mark S 
Palmer/Enron Communications@Enron Communications
		 cc: Jeff Dasovich/NA/Enron@Enron, James D Steffes/NA/Enron@Enron
		 Subject: 

These 3 issues will be discussed at your Tuesday afternoon meeting with EES:

what to do about forcing the utilities to pay delinquent PX credits
Through December, the total arrearage is about $220M total, mostly from 
PG&E.  Neither utility is paying.  Vicki Sharpe is lining up bankruptcy 
counsel.

should the new 1 cent surcharge be passed on to our customers
Vicki has not said yet whether our contracts allow passthrough, although she 
has hinted it would require a very aggressive interpretation of the contract.
 
should we try to return our customers to utility bundled service
Aside from the modifications to our customer contracts that have to take 
place, an even stickier issue is to get the utilities to take them back.  
Even if the utilities are required to do so, forms have to be processed and 
meters have to be changed out.  (We have our own meters on our accounts.)  
This could not happen quickly.  Of course, this action mitigates against the 
risk of the rate freeze ending but does nothing for the credit problem, other 
than to keep the exposure from getting larger.

On Wednesday, there will be a pre-hearing conference at the CPUC on the next 
phase of the end-the-rate-freeze case.  Jeff and I have talked about this and 
think we can decide what our involvement will be (witnesses, positions, etc.) 
after a schedule is set.  For now, the strategy is to make sure the CPUC on 
Wednesday adopts a schedule that deals with all the issues they must deal 
with about the rate freeze. 

(Rick, I will be in San Francisco through Wednesday meeting with Mike Day and 
working with Roger Yang to identify all those issues.)
 

`,
    },
    {
      id: 1139,
      question: "When is the Astros group game against the Cubs?",
      answer: "Thursday, April 27, at 3:05 PM.",
      source_email: `You have a ticket - we will see you there, with you pager on!  Patti will get 
your ticket to you before Thursday.  




Scott Pleus
04/21/2000 01:50 PM
To: Sally Beck/HOU/ECT@ECT
cc:  
Subject: Re: Astros Group Tickets for Thursday, April 27, vs. Chicago Cubs  

If tix avail, would love to go.  Thanks for the offer.

Scott

PS.  My wife is due in about 10 days so I am on call around the clock.


   
	Enron North America Corp.
	
	From:  Sally Beck                           04/20/2000 04:52 PM
	

Sent by: Patti Thompson
To: Kristin Albrecht/HOU/ECT@ECT, Sheila Glover/HOU/ECT@ECT, Brenda F 
Herod/HOU/ECT@ECT, Michael E Moscoso/HOU/ECT@ECT, Eugenio Perez/HOU/ECT@ECT, 
Scott Pleus/HOU/ECT@ECT, Leslie Reeves/HOU/ECT@ECT, Stephen P 
Schwarz/HOU/ECT@ECT, Mary Solmonson/HOU/ECT@ECT, Sheri Thomas/HOU/ECT@ECT, 
Kim Melodick/HOU/ECT@ECT, Norma Villarreal/HOU/ECT@ECT, Scott 
Mills/HOU/ECT@ECT, Kevin Sweeney/HOU/ECT@ECT, Scott Earnest/HOU/ECT@ECT, 
James Scribner/Corp/Enron@Enron, David Maxwell/HOU/ECT@ECT, Susan 
Harrison/HOU/ECT@ECT, Steve Jackson/HOU/ECT@ECT
cc:  
Subject: Astros Group Tickets for Thursday, April 27, vs. Chicago Cubs

Sally has gotten a block of tickets for next Thursday's afternoon Astros game 
and hopes everyone will be able to join her.  Here are the details:

Thursday, April 27, at 3:05 PM vs. Chicago Cubs

Please email Sally & let her know if you will be able to attend.

Thanks,
Patti
x-39106



`,
    },

    {
      id: 3916,
      question:
        "What countries are on the boycott list for e-commerce trading?",
      answer:
        "Bahrain, Iraq, Kuwait, Lebanon, Libya, Oman, Qatar, Saudi Arabia, Syria, United Arab Emirates, Republic of Yemen.",
      source_email: `Louise and Mark,

As we discussed in our meeting last Thursday, set forth below is the most 
recent list of the boycott countries for you to take into account when making 
the appropriate system changes to prohibit trading with counterparties 
located in such countries:

Bahrain

Iraq

Kuwait

Lebanon

Libya

Oman

Qatar

Saudi Arabia

Syria

United Arab Emirates

Republic of Yemen

This list is published quarterly, so we will inform you of any changes to the 
list as they are published in the future.

Best regards,

Jeff`,
    },
    {
      id: 2770,
      question:
        "What is my confirmation number for my Continental Airlines flight to Colorado Springs?",
      answer: "N1BTZH",
      source_email: `Thank you for making your OnePass travel arrangements with Continental
Airlines.  Your flight information is listed below.  Replies to this
e-mail will not be returned.  For changes or questions about your E-Ticket
receipt, call toll free 1-800-621-7467 for Domestic travel or
1-800-344-1411 for International travel.  To help expedite your request,
please be sure to have your confirmation number available.
------------------------------------------------------------

Issue Date: December 30, 1998
------------------------------------------------------------
Attention: MR MARK TAYLOR
Your Confirmation number is: N1BTZH

------------------------------------------------------------
Trip Details
------------------------------------------------------------
*Flight: from HOUSTON/IAH to COLO SPRINGS COLO

Day and Date: Thu, 2/4/99
Flight: 505
Class: M
Depart: HOUSTON/IAH, 12:05PM
Arrive: COLO SPRINGS COLO, 1:25PM
Equipment: 737-500
Meal: Snack
------------------------------------------------------------
Flight: from COLO SPRINGS COLO to HOUSTON/IAH

Day and Date: Sun, 2/7/99
Flight: 1778
Class: M
Depart: COLO SPRINGS COLO, 2:25PM
Arrive: HOUSTON/IAH, 5:34PM
Equipment: 737-500
Meal:
------------------------------------------------------------
Party of (1):

BOCKIUS/EDWARDMR
Seat(s) listed in flight order and subject to change: ---/---
Ticket Number: 0052718438260
------------------------------------------------------------
Base: $0.00
Tax: $0.00
Per Person: $0.00
E-Ticket Total: $0.00
Method of payment: N/A

OnePass Account Debited: SC471253
OnePass Miles Debited: 25,000
Reward Used: CC0SM

------------------------------------------------------------
Reward Rules
 ONE PAX RWD CC0SM/NONREF/END VALID CO/COEX

------------------------------------------------------------
OnePass E-Ticket Reminders
- Please be sure to bring positive identification
- As with all airline tickets, your E-Ticket is non-transferable
- Enjoy curbside baggage check-in by presenting this receipt
- If your travel plans change call Continental Domestic Reward Desk at
1-800-621-7467
- For up to the minute flight information call 1-800-784-4444
- Redeposit unused reward upon payment of $35.00 fee by calling
1-800-621-7467
- OnePass Rewards are valid one year from date of mileage withdrawal
- Flight boarding begins 35 to 50 minutes prior to departure, you must
check in at least 20 minutes prior to departure to retain your assigned
seats and 10 minutes prior to departure to retain your reservation
- Reward travel is subject to the terms and conditions of OnePass as set
forth in the Member's Guide
------------------------------------------------------------
E-Ticket Machine Check-in
Don't stand in line, try our E-Ticket Machine (ETM) with your OnePass
Elite or major credit card to receive a boarding pass, select or change
your seat, make simple flight changes and upgrade eligible Gold or Silver
Elite members. Your credit card will NOT be charged to activate the ETM.
E-Ticket Machines at select ticket counters can check bags.

* In HOUSTON/IAH, look for the E-Ticket Machines at each ticket counter,
in the lobby, the Presidents Club, the service center, and near gates C24,
C33, C34, C43
------------------------------------------------------------

Enjoy a 50% fare class bonus when you purchase and travel with Continental
First Class or BusinessFirst fares.  BusinessFirst is available on
Continental flights to Europe, on select flights to South America and on
transpacific flights.

Please provide your Personal Identification Number (PIN) when making any
kind of modification to your OnePass account.  If you need to change your
PIN, call InfoPass at (713) 785-8999 and select option 7.


Replies to this e-mail will not be returned.  For changes or questions
about your E-Ticket receipt, call toll free 1-800-621-7467 for Domestic
travel or 1-800-344-1411 for International travel.  To help expedite your
request, please be sure to have your confirmation number available.

We wish you a pleasant trip and look forward to serving your travel needs
again soon.

Conditions of Contract
Air transportation is subject to Continental's Conditions of Contract
including Contract of Carriage terms or international tariff rules. Such
conditions include, without limitation, limits on liability for personal
injury, death, and baggage claims; claims restrictions and limitation
periods; rules on reconfirmation of reservations, check-in times and
refusal to carry; and rules relating to schedule irregularities and
delays. A copy of Continental's Conditions of Contract can be obtained
from any Continental ticketing facility, Continental's ticket jacket, or
by calling 1-800-525-0280.

Be sure to visit our website at http://www.flycontinental.com

Thank you for choosing Continental Airlines!`,
    },
    {
      id: 2796,
      question: "Where can I find the revised anexb.doc form?",
      answer: "It is located in atty.fms/swaps/current forms/anexb.doc.",
      source_email: `We have completed the revisions to anexb.doc (the document used to prepare 
credit for omnibus confirmations).  It has been moved into the attorney forms 
bank and is located in atty.fms/swaps/current forms/anexb.doc.  The prior 
form has been moved to atty.fms/swaps/old forms/oldanexb.doc.`,
    },
  ];

  return (
    <div ref={tableRef} className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 border border-gray-300 table-fixed">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider border border-gray-300 dark:border-gray-600 w-1/4"
            >
              Question
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider border border-gray-300 dark:border-gray-600 w-1/4"
            >
              Answer
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider border border-gray-300 dark:border-gray-600 w-1/2"
            >
              Source
            </th>
          </tr>
        </thead>
        <tbody className="bg-white dark:bg-gray-800">
          {examples.map((example) => (
            <tr
              key={example.id}
              className="hover:bg-gray-50 dark:hover:bg-gray-700"
            >
              <td className="px-6 py-4 whitespace-normal text-sm text-gray-900 dark:text-gray-100 align-top font-sans border border-gray-300 dark:border-gray-600">
                {example.question}
              </td>
              <td className="px-6 py-4 whitespace-normal text-sm text-gray-900 dark:text-gray-100 align-top font-sans border border-gray-300 dark:border-gray-600">
                {example.answer}
              </td>
              <td className="px-6 py-4 whitespace-normal text-sm text-gray-900 dark:text-gray-100 align-top font-sans border border-gray-300 dark:border-gray-600">
                <div className="whitespace-pre-wrap text-xs text-gray-600 dark:text-gray-300">
                  {expandedSources[example.id]
                    ? example.source_email
                    : truncateEmail(example.source_email)}
                  {!expandedSources[example.id] &&
                    truncateEmail(example.source_email) !==
                      example.source_email && (
                      <button
                        onClick={() => toggleSource(example.id)}
                        className="ml-2 mt-1 inline-block px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-800 text-xs rounded-full transition-colors"
                      >
                        ...
                      </button>
                    )}
                  {expandedSources[example.id] && (
                    <button
                      onClick={() => toggleSource(example.id)}
                      className="ml-2 mt-1 inline-block px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 text-xs rounded-full transition-colors"
                    >
                      collapse
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
